<template>
  <main>
    <div class="container content_padding pt-4 pb-5">
      <div class="row mb-4">
        <SearchInput v-model="inputValue" />
      </div>
      <section>
        <div class="row" data-aos="fade-up"
          style="display: flex;align-items: center;padding: 1rem 0;border-bottom: 1px solid #F1F1F1;">
          <div class="col-md-12 row  pt-2 pb-2">
            <h6 class="card-title col-md-6 text-left">SM6064-45-01</h6>
            <p class="card-text col-md-6 text-right text-muted">
              2024-12-27
            </p>
          </div>
          <div class="col-md-12 row text-right">
            <p class="card-text  col-md-6 text-left text-muted"> effective and high-quality work light for ang
              construction.</p>
            <div class="col-md-6 text-right  ">
              <img class="text-right text-muted" src="/assets/img/Download/PMDownload.png" style="max-height: 1.6rem;">
            </div>
          </div>
        </div>
        <div class="row" data-aos="fade-up"
          style="display: flex;align-items: center;padding: 1rem 0;border-bottom: 1px solid #F1F1F1;">
          <div class="col-md-12 row pt-2 pb-2">
            <h6 class="card-title col-md-6 text-left">SM6064-45-01</h6>
            <p class="card-text col-md-6 text-right text-muted">
              2024-12-27
            </p>
          </div>
          <div class="col-md-12 row text-right">
            <p class="card-text col-md-6 text-left text-muted"> effective and high-quality work light for ang
              construction.</p>
            <div class="col-md-6 text-right">
              <img class="text-right text-muted" src="/assets/img/Download/PMDownload.png" style="max-height: 1.6rem;">
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import SearchInput from '@/components/common/SearchInput.vue';

export default {
  name: 'OEMarket',
  components: {
    SearchInput
  },
  computed: {
  },
  methods: {
  }
};
</script>

<style scoped>
@import '../../assets/css/main.css';
</style>
